import React, { ReactNode } from 'react';
import './Heading.scss';

interface IHeadingProps {
  headline: string;
  items?: any[];
  body?: ReactNode;
  children?: ReactNode;
}

const Heading = ({ headline, items, body, children }: IHeadingProps) => (
  <div className="heading">
    <div className="heading__headline">{headline}</div>
    {(children || body) && (
      <div className="heading__body">{children ?? body}</div>
    )}
    {items && (
      <div className="heading__items">
        {items.map((i: any, x: number) => (
          <div key={x} className="heading__item">
            <div className="heading__value">{i.value}</div>
            <div className="heading__key">{i.key}</div>
          </div>
        ))}
      </div>
    )}
  </div>
);

export default Heading;
